if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }

      // 2026-07-18: self-rotating bar (nav arrows are hidden via custom CSS).
      // Wraps around instead of stopping at the ends. Hover-pause applies ONLY on devices
      // with a real hover pointer: on touchscreens a tap registers as pointerenter and
      // never "leaves", which froze rotation permanently on phones. On touch devices a
      // manual swipe just pauses briefly, then rotation resumes.
      if ( this.length > 1 ) {
        this.startAutoRotate();
        if ( window.matchMedia('(hover: hover)').matches ) {
          this.addEventListener('pointerenter', ()=>{ this.stopAutoRotate(); });
          this.addEventListener('pointerleave', ()=>{ this.startAutoRotate(); });
        } else {
          this.addEventListener('touchstart', ()=>{ this.stopAutoRotate(); }, { passive: true });
          this.addEventListener('touchend', ()=>{
            clearTimeout(this.resumeTimer);
            this.resumeTimer = setTimeout(()=>{ this.startAutoRotate(); }, 4000);
          }, { passive: true });
        }
      }

    }

    startAutoRotate() {
      if ( this.autoRotate ) return;
      this.autoRotate = setInterval(()=>{
        this.index = ( this.index + 1 ) % this.length;
        this.slider.scrollTo({
          top: 0,
          left: this.content[this.index].offsetLeft,
          behavior: 'smooth'
        });
      }, 5000);
    }

    stopAutoRotate() {
      clearInterval(this.autoRotate);
      this.autoRotate = null;
    }

    changeSlide(direction) {

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}